@if (editMode) {
  <div>
    <div class="field title-selection">
      <label>{{ 'COMMUNICATIONS.TITLE' | translate }}</label>
      <div>
        <input
          (ngModelChange)="titleChanged($event)"
          class="input is-small is-fullwidth"
          type="text"
          placeholder="{{ 'COMMUNICATIONS.TITLE' | translate }}"
          [(ngModel)]="title" />
      </div>
    </div>
  </div>
}
@if (!editMode && hideFromPreview !== true) {
  <div>
    @if (title) {
      <div class="title">
        {{ title }}
      </div>
    }
    <div
      [ngStyle]="{ 'max-width': imageWidth }"
      class="map-image-container">
      <img
        class="map-image"
        [ngStyle]="{ 'max-width': '100%' }"
        [src]="imageSource" />
    </div>
  </div>
}
